import Autoplay from "embla-carousel-autoplay"

import {
    Carousel,
    CarouselContent,
    CarouselItem,
} from "@/components/ui/carousel"

import { Card } from "@/components/ui/card"
import { useQuery } from "@tanstack/react-query"
import type { CarouselImages } from "@/types"
import { API } from "@/config"
import { Spinner } from "@/components/ui/spinner"
import ErrorImage from "@/assets/error-image-loading.png"

const LoginCarousel = () => {
    const queryFn: () => Promise<CarouselImages> = () => fetch(`${API}/Service/ImagesLogin`).then(res => res.json())
    const { data, isLoading, error } = useQuery({
        queryKey: ["images"],
        queryFn,
        retry: false,
        select: (({ data }) => data)
    })

    if (isLoading) return (
        <Carousel opts={{ loop: true }} className="w-full">
            <CarouselContent className="flex justify-center items-center">
                <Spinner className="size-8 text-black"/>
            </CarouselContent>
        </Carousel>
    )

    if (error) return (
        <Carousel opts={{ loop: true }} className="w-full">
            <CarouselContent>
                <img src={ErrorImage} alt="error loading" />
            </CarouselContent>
        </Carousel>
    )

    if (data) return (
        <Carousel plugins={[Autoplay({ delay: 3000 })]} opts={{ loop: true }} className="w-120">
            <CarouselContent>
                {data.map(({ ImagenVertical }, index) => (
                    <CarouselItem className="h-190" key={index}>
                        <Card className="p-0">
                            <img src={ImagenVertical} className="rounded-xl" loading="eager" fetchPriority="high" alt="" />
                        </Card>
                    </CarouselItem>
                ))}

            </CarouselContent>
        </Carousel>
    )
}

export default LoginCarousel
